module.exports = __webpack_public_path__ + "static/infuraShirtZoom-155d65bd478e96fc13b8c4fd0af568cc.png";